"use client";

import styles from "./info-tabs.module.scss";

const BackgroundTab = ({
  handleLinkClick,
}: {
  handleLinkClick: (event: React.MouseEvent, referenceId: string) => void;
}) => {
  return (
    <div className={styles.tabContent}>
      <h2>Background</h2>
      <p>
        Ireland’s peatlands, occurring as <strong>raised bogs</strong>,{" "}
        <strong>blanket bogs</strong>, or <strong>fens</strong>, host
        specialised plant and animal communities, which contribute to global
        biodiversity and carbon regulation. However, exploitation has reduced
        the habitat distribution and damaged the ecohydrological functioning of
        remaining areas.
      </p>
      <br />
      <p>
        In the past 100 years, wetland cover has reduced by up to half globally
        and by up to two-thirds in Western Europe{" "}
        <a href="#ref-owen-2007" onClick={(e) => handleLinkClick(e, "ref-owen-2007")}>Owen, 2007</a>.
        As a result, peatlands are now among Europe’s most threatened ecosystems
        and the conservation and restoration of remaining areas is an
        international concern.
      </p>
      <br />
      <p>
        A peatland system of particular importance is{" "}
        <strong>“active”, or peat-forming, raised bogs</strong>. These habitats
        have disappeared almost entirely in temperate climates as a result of
        land reclamation for agriculture and forestry, fuel production and
        urbanisation.
      </p>
      <br />
      <p>
        Despite these losses, Ireland contains one of the highest concentrations
        of wetlands in Europe and approximately
        <strong>
          {" "}
          60% of the remaining raised bog habitat area in the European Union
          (EU)
        </strong>
        .
      </p>
      <br />
      <p>
        However, mechanised commercial peat extraction, combined with marginal
        turf cutting, has resulted in the loss of
        <strong> &gt;80% of the original raised bog area</strong>. As a result,
        despite peatland covering over 20% of the Irish landscape, only 9% of
        the original raised bog area is considered suitable for conservation —
        and <strong>less than 1%</strong> is still actively forming peat{" "}
        <a href="https://www.npws.ie/peatlands-and-turf-cutting/management-plans">
          NPWS, 2017
        </a>
        .
      </p>
    </div>
  );
};

export default BackgroundTab;
